import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomError } from '@components/Error/Error';

const Error500Page: FC = () => {
    const { t } = useTranslation();

    return (
        <CustomError
            title={t('error500Page.title')}
            subTitle={t('error500Page.subTitle')}
            text={t('error500Page.text')}
        />
    );
};

export default Error500Page;
